
export const finance = {
  accountingHub: {
    sidebar: {
      redemptionHistory: "ประวัติการแลกของรางวัล",
      chartOfAccounts: "ผังบัญชี"
    }
  },
  accounting: {
    title: "บัญชีและการเงิน",
    loading: "กำลังโหลดข้อมูลบัญชี...",
    kpi: {
      pointsRedeemed: "แต้มที่ถูกแลกไป",
      rewardCost: "ต้นทุนของรางวัล"
    },
    cards: {
      totalRevenue: "รายรับรวม",
      cogs: "ต้นทุนขาย (COGS)",
      grossProfit: "กำไรขั้นต้น",
      netProfit: "กำไรสุทธิ",
      expenses: "ค่าใช้จ่ายดำเนินงาน"
    },
    sections: {
      clinicRevenue: "รายรับฝั่งคลินิก (Clinic)",
      retailRevenue: "รายรับฝั่งร้านค้า (Retail)",
      medicalServices: "ค่ารักษาและใบรับรอง",
      generalGoods: "สินค้าทั่วไป",
      topItems: "รายการยอดนิยม"
    }
  },
  billing: {
    title: "แพ็กเกจและการเรียกเก็บเงิน",
    description: "จัดการแผนของคุณและดูประวัติการเรียกเก็บเงิน",
    currentPlan: "แพ็กเกจปัจจุบัน",
    status: "สถานะ:",
    manageButton: "จัดการการสมัครสมาชิก",
    perMonth: "/ เดือน",
    usersUnit: "เคสใบสั่งยา",
    productsUnit: "รายการยา",
    unlimited: "ไม่จำกัด",
    upgradeButton: "อัปเกรด",
    currentPlanButton: "ใช้งานอยู่",
    features: {
      reporting: "ระบบรายงานผล",
      aiorder: "ระบบสั่งงานด้วยเสียง (AI)",
      telemedicine: "แพทย์ทางไกล",
      loyalty: "ระบบลอยัลตี้",
      accounting: "บัญชี",
      partnernetwork: "เครือข่ายพันธมิตร",
      nfccards: "ระบบบัตรสมาชิก NFC",
      compliancereports: "รายงาน (ภท.27/28)"
    },
    summary: {
      title: "สรุปยอดบิลเดือนนี้",
      estimatedTotal: "ยอดรวมโดยประมาณ",
      casesUsed: "จำนวนเคสที่ใช้ไป",
      basePlan: "ค่าบริการรายเดือน",
      overageFees: "ค่าธรรมเนียมส่วนเกิน",
      total: "รวมทั้งสิ้น",
      remaining: "เหลืออีก {{count}} เคส ในแพ็กเกจ",
      overageWarning: "เกินโควตา {{count}} เคส (ส่วนเกินละ {{rate}} บาท)"
    }
  }
};
